import { $LOADER, $PAGE } from "~/util/Loaders";
import { loadMarkdown } from "~/util/Markdown.server";
import { renderMarkdown } from "~/util/MarkdownRenderer";

$PAGE({
  path: "md",

  loader: $LOADER?.(async (cx) => {
    const src = `
# Top Title
## Hello

Hi *guys*!

Ланцэ-хуянцэ: :item[lancia]

Антарас-пидорас: :npc[antaras]

Квест-хуест: :quest[216]
`;

    const md = await loadMarkdown(src, cx.gd.all_gd!, cx.realm.lang, "gf");

    return {
      id: 1,
      name: "Markdown",
      md,
    };
  }),

  meta: (args) => {
    return {
      title: "MD",
    };
  },

  render: ({ data }) => {
    return <div>{renderMarkdown(data.md)}</div>;
  },
});
